import {createSlice} from '@reduxjs/toolkit'
import {
    ROUTE_PATH
} from "../../app/constants"

const collectorDetailsState = () => ({
    "collection-agency-collector" : {
        header : 'Applicant information',
        text : [
            "Provide information about the applicant"
        ],
        navigation : {
            next : ROUTE_PATH.CRIMINAL_HISTORY_QUESTION
        }
    },
    "debt-management-agent" : {
        header : 'Applicant information',
        text : [
            "Provide information about the applicant"
        ],
        navigation : {
            next : ROUTE_PATH.CRIMINAL_HISTORY_QUESTION
        }
    }
})

const collectorDetailsSlice = createSlice({
    name: 'collectorDetails',
    initialState : collectorDetailsState(),
    reducers : {}
})

export default collectorDetailsSlice.reducer
